<div class="bl-margin-bottom--32" id="{{ card.id }}" [attr.data-automation-id]="card?.automationId">
  <ng-container *ngIf="card?.config?.reviewRendererType; else defaultTemplate">
    <cu-review-resolver
      [reviewComponentType]="card.config.reviewRendererType"
      [flow]="flow"
      [page]="page"
      [card]="card"
      [editUrlFn]="editUrlFn"
    ></cu-review-resolver>
  </ng-container>
  <ng-template #defaultTemplate>
    <div class="bl-margin-bottom--16" *ngIf="title">
      <p class="bl-align-self--center bl-margin-bottom--24 bl-margin-top--24 bl-margin-top-sm--0 bl-text-style--secondary-text-1  ">
        {{page.config.reviewSubTitle}}
        @if(isNotProductSelection && allowEdit && page?.showEditOnCondensedCards){ @if(page.config.lockOnPrefill){
        <span class="bl-float--right bl-font-size--22 bl-font-color--silver"><i class="cu-icons cu-lock"></i></span>
        } @else{
        <button
          id="edit-{{ card.id }}"
          type="button"
          [routerLink]="editRouteLink"
          (click)="goToEdit()"
          [fragment]="card.id"
          class="bl-button bl-button-small bl-button-reverse bl-float--right"
        >
          <span class="bl-font-color--primary"
            ><span class="bl-font-size--14 cu-icons cu-edit bl-margin-right--4"></span> {{ 'applicationReview/edit' | dictionary }}
            <span class="bl-screen-reader-only"> {{ getCardTitle() }} </span></span
          >
        </button>
        } }
      </p>
      <h3 class="bl-font-size--22 bl-font-weight--900 bl-margin-bottom--8">{{ title }}</h3>
    </div>
    <section *ngIf="card.id === 'oao-additional-question' || card.id === 'ola-additional-question'">
      <ecp-additional-ques-review [cardId]="card.id"></ecp-additional-ques-review>
    </section>
    <ng-container *ngFor="let item of displayFields">
      <div *ngIf="checkBeneficiaryAddress(item); else fieldGroupCard" class="bl-display--flex bl-margin-bottom--16 bl-margin-top--32">
        <h3 class="bl-font-size--22 bl-font-weight--900 bl-margin-bottom--8">Address (Beneficiary {{ item.field.iterationId + 1 }})</h3>
      </div>
      <ng-template #fieldGroupCard>
        <div *ngIf="checkFieldGroupCard(item); else OtherField">
          <h3
            class="bl-font-size--16 bl-font-weight--900 bl-margin-bottom--8"
            [innerHTML]="item.field.config.subLabel || item.field.label"
          ></h3>
        </div>
      </ng-template>
      <ng-template #OtherField>
        <ecp-review-field [fieldSummary]="item"></ecp-review-field>
      </ng-template>
    </ng-container>
    <ng-container *ngIf="card.id === 'ola-eligibility-selection' || card.id === 'oao-eligibility-selection'">
      <ecp-oao-eligibility-review [card]="card"></ecp-oao-eligibility-review>
    </ng-container>
  </ng-template>
</div>
